import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-check-email',
    templateUrl: './check-email.component.html',
    styleUrls: [ './check-email.component.css' ]
})
export class CheckEmailComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/check-email/check-email.component.ts